export const FILTER_PERIOD = 'period';
export const FILTER_MASTER_CAMPAIGNS = 'masterCampaignIds';
export const FILTER_AGENCIES = 'agencyIds';
export const FILTER_INFLUENCERS_CHANNELS = 'influencerChannelIds';
export const FILTER_APPLICATIONS = 'applicationIds';
export const FILTER_NETWORKS = 'networkIds';
export const FILTER_PLATFORMS = 'platformIds';
export const FILTER_COUNTRIES = 'countryCodes';

export const FILTERS_DEPENDENCIES = {
  [FILTER_MASTER_CAMPAIGNS]: [FILTER_PERIOD],
};

export const COLUMN_ID = 'id';
export const COLUMN_GG_CAMPAIGNS = 'goGameCampaigns';
export const COLUMN_PERIOD = 'masterCampaignStartDate';
export const COLUMN_NAME = 'name';
export const COLUMN_MASTER_CAMPAIGN = 'masterCampaign';
export const COLUMN_AGENCY = 'agency';
export const COLUMN_INFLUENCER_CHANNEL = 'influencerChannel';
export const COLUMN_APPLICATION = 'application';
export const COLUMN_NETWORK = 'network';
export const COLUMN_PLATFORMS = 'platforms';
export const COLUMN_COUNTRY = 'country';
export const COLUMN_COST_MODEL = 'costModel';
export const COLUMN_PAYOUT_RATE = 'payout';
export const COLUMN_OWNER = 'owner';
export const COLUMN_LAST_UPDATED_BY = 'updatedBy';
export const COLUMN_LAST_UPDATED_DATE = 'updated';
export const COLUMN_CREATED_BY = 'createdBy';
export const COLUMN_CREATED_DATE = 'created';

export const ACTION_ACTIVE = 'Active';
export const ACTION_INACTIVE = 'Inactive';
export const ACTION_EDIT = 'Edit';
export const ACTION_DELETE = 'Delete';

export const TEMPLATE_UPDATE_INFLUENCER_CAMPAIGN = 'updatingCampaign';
